import React from "react";

import Graphics503 from "../../assets/images/404.svg"; // Replace with an appropriate 503 image

const ServiceUnavailableScreen = () => {
  return (
    <>
      <div className="container mx-auto p-4 md:p-8 min-h-[80vh]">
        <div className="flex justify-center items-center w-full h-full min-h-[80vh]">
          <div className="flex items-center flex-wrap sm:flex-nowrap gap-4 max-w-[840px]">
            <div className="w-full sm:w-1/2">
              <h2 className="heading text-[38px] leading-[1.2] font-semibold uppercase mb-2">503 Error</h2>
              <p className="text-[26px] leading-[1.3] font-bold mb-2">Service Unavailable</p>
              <p className="font-bold mb-2">What might be happening:</p>
              <ul className="list-disc ml-3.5">
                <li>The server is under maintenance.</li>
                <li>Please try again later.</li>
              </ul>
            </div>
            <div className="w-full sm:w-1/2">
              <img src={Graphics503} alt="Service Unavailable" className="w-[auto] h-[280px]" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceUnavailableScreen;
